import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

function PaymentBrick({
  publicKey,
  amount,
  userData,
  selectedCourse,
  containerId = "paymentBrick_container",
}) {
  const paymentBrickInstance = useRef(null);
  const userInfo = useSelector((state) => state.user);
  const [sdkReady, setSdkReady] = useState(false);

  const { REACT_APP_URL_API } = process.env;

  userData = {
    ...userData,
    firstName: userInfo?.firstName,
    lastName: userInfo?.lastName || "",
    email: userInfo?.email,
  };

  console.log("Datos del usuario:", userData);
  
  // Cargar el script solo una vez
  useEffect(() => {
    const scriptUrl = "https://sdk.mercadopago.com/js/v2";
    if (window.MercadoPago) {
      setSdkReady(true);
      return;
    }
    if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => setSdkReady(true);
      document.body.appendChild(script);
    } else {
      const checkReady = setInterval(() => {
        if (window.MercadoPago) {
          setSdkReady(true);
          clearInterval(checkReady);
        }
      }, 100);
      return () => clearInterval(checkReady);
    }
  }, []);

  useEffect(() => {
    if (!sdkReady) return;

    async function initBrick() {
      if (paymentBrickInstance.current?.destroy) {
        paymentBrickInstance.current.destroy();
        paymentBrickInstance.current = null;
      }

      const mp = new window.MercadoPago(publicKey, { locale: "es-AR" });
      const bricksBuilder = mp.bricks();

      const metadata = {
        user_id: userInfo?.id,
        course_title: selectedCourse,
        course_id: userData?.courseId,
      };

      const settings = {
        initialization: {
          amount,
          payer: {
            email: userData?.email,
          },
          metadata,
        },
        customization: {
          paymentMethods: {
            creditCard: "all",
            debitCard: "all",
            ticket: "all",
            maxInstallments: 1,
          },
          visual: {
            style: { theme: "default" },
          },
        },
        callbacks: {
          onReady: () => console.log(" Payment Brick listo"),
          onSubmit: async ({ formData }) => {
            formData.metadata = metadata;


            return fetch(`${REACT_APP_URL_API}/mp/process_payment`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(formData),
            })
              .then(async (response) => {
                if (!response.ok) {
                  console.error("Error en el pago:", response.statusText);
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `Ocurrió un error al procesar el pago: ${response.statusText}`,
                    confirmButtonText: "Aceptar",
                  });
                  const errorBody = await response.json();
                  return Promise.reject(errorBody);
                }
                return response.json();
              })
              .then((data) => {
                Swal.fire({
                  icon: "success",
                  title: "Pago exitoso",
                  text: `Gracias por tu compra de ${selectedCourse}!`,
                  confirmButtonText: "Aceptar",
                });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: `Ocurrió un error al procesar el pago: ${error.message}`,
                  confirmButtonText: "Aceptar",
                });
                console.error("Error en el pago:", error.message);
              });
          },
          onError: (error) => {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: `Ocurrió un error al procesar el pago: ${error.message}`,
              confirmButtonText: "Aceptar",
            });
            console.error("Error en el pago:", error.message);
          },
        },
      };

      paymentBrickInstance.current = await bricksBuilder.create(
        "payment",
        containerId,
        settings
      );
    }

    initBrick();

    return () => {
      if (paymentBrickInstance.current?.destroy) {
        paymentBrickInstance.current.destroy();
        paymentBrickInstance.current = null;
      }
    };
  }, [sdkReady, publicKey, amount, userData, selectedCourse, containerId]);

  return <div id={containerId} style={{ minHeight: "300px" }} />;
}

export default PaymentBrick;
